import API_BASE_URL from './ApiConfig';


const acceptRequest = async (certificateRequestId, pinCode) => {
    try {
        const formData = new FormData();
        formData.append('pin_code', pinCode);

        const response = await fetch(`${API_BASE_URL}/api/certificate_requests/${certificateRequestId}`, {
            method: 'POST',
            body: formData,
            credentials: 'include',
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data.error || 'Failed to accept certificate request');
        }

        const data = await response.json();
        return { success: true, message: data.message };
    } catch (error) {
        throw new Error(error.message || 'An error occurred');
    }
};

export default acceptRequest;
